import makeCrud from './crud'
export default makeCrud('localization_country_state')
